import { push, isContextChange, isPatientChange, getContextName, contextToPath } from '../Helper/routeHelpers'
import * as modalActions from 'actions/modalActions'
import { put, all, select, call } from 'redux-saga/effects'
import { delay } from 'Helper/customReduxEffects.js'
import { setScreen } from 'actions/interactableActions.js'
import { sendWindowMessage } from 'actions/windowMessagingActions.js'
import _ from 'lodash'
import {
  allWindows
} from 'data/systemWindows'

export function appLocationChange(action) {
  const { url } = action
  push(url)
}

export function * clearConnectionModals(action) {
  const { value } = action
  if (value === 0) {
    // if we are setting fail count back to 0 then api calls are succeeding and
    // we should close any modals currently open that are indicating connection
    // issues
    yield put(modalActions.closeModal('connection_problems'))
  }
}

function * getWindowConfig(windowConfig, appContext = null) {
  const router = yield select(state => state.router)
  // we need to find and add the context based window config
  if (appContext === null) {
    appContext = getContextName(router.location.pathname)
  }

  // next find the context specific window config so its defaults are available
  const windowConfigs =
    appContext != null
      ? yield select(state => state.appConfig[appContext]?.windows || [])
      : []

  const contextWindowConfig =
    windowConfigs.find(config => config.ref === windowConfig.ref) || {}

  const generalDefaultConfig = {
    name: _.startCase(windowConfig.ref),
    x: '10%',
    y: '10%',
    width: '80%',
    height: '80%'
  }
  // find hard coded window defaults
  const foundWindow =
    allWindows.find(win => {
      return win.id === windowConfig.ref &&
        win.contexts.find(context => context.name === appContext) != null
    }) || {}
  const foundWindowConfig = foundWindow.windowConfig || {}
  const foundWindowContextConfig = foundWindow.contexts?.find(context => context.context === appContext) || {}

  const codedDefaultWindowConfig = { ...foundWindowConfig, ...foundWindowContextConfig, ref: foundWindow.id }

  return {
    defaultConfig: {
      ...generalDefaultConfig,
      ...codedDefaultWindowConfig,
      ...contextWindowConfig,
      ...windowConfig
    },
    contextConfig: contextWindowConfig
  }
}

export function * setScreenContext(action) {
  const { context, windows, messages, leaveSameContextWindowsOpen } = action
  const router = yield select(state => state.router)
  const sameContext = !(yield call(isContextChange, context, router))
  const path = contextToPath(context)
  push(path, sameContext)
  const contextName = getContextName(context)
  const samePatient = contextName === 'patientDisplay' ? !(yield call(isPatientChange, context, router)) : false

  while (true) {
    // the router pathname could include leading and/or trailing /s but we know the path name wont.
    // so we remove them
    const newPath = yield select(state => state.router?.location?.pathname)
    if (_.trim(newPath,'/') === path) {
      // wait for router to update and user to navigate
      break
    } else {
      yield delay(250)
    }
  }

  if (sameContext && (samePatient || leaveSameContextWindowsOpen)) {
    // leave windows open
    const openWindows = yield select(state => state.interactableState.windows)
    Object.keys(openWindows).forEach(ref => {
      if (windows.findIndex(win => win.ref === ref) === -1) {
        // this is a currently open window that wasn't in the list of new windows to open
        // so we should add it to the list so the window remains open
        windows.push(openWindows[ref])
      }
    })
  }
  // fill in any window info that is missing with sensible defaults
  // const appConfig = yield select(state => state.appConfig)

  yield all(
    windows.map(function * (windowConfig, idx) {
      const config = yield call(
        [this, getWindowConfig],
        windowConfig,
        contextName
      )
      windows[idx] = config.defaultConfig
    })
  )
  // repackage messages with the correct info
  const newMessages = messages.map(wrapper => {
    const { recipient, message, sender, config } = wrapper
    return { recipient, message, sender, config }
  })
  // update interactable to show selected window(s)
  yield put(setScreen({ windows }, !sameContext /*contextChange*/, !samePatient /*patientChange*/, newMessages))
}
